import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";

const DeleteEvent = ({ 
  setIsToggleDelete, 
  DeleteEvent, 
  pending,
  eventName // Optional: event name for better UX
}) => {
  return (
    <div className="w-100">
      <h5 className="text-danger mb-3">
        Delete Event
      </h5>
      
      <p className="text-muted">
        Are you sure you want to delete{" "}
        <strong>"{eventName || "this event"}"</strong>?
      </p>
      
      <p className="small text-warning">
        <i className="ri-information-line me-1"></i>
        This event will be moved to Archives and can be restored later.
      </p>
      
      <div className="modal-footer d-flex justify-content-between pt-3">
        <button
          onClick={() => setIsToggleDelete(false)}
          type="button"
          className="btn btn-outline-secondary"
          disabled={pending}
        >
          Cancel
        </button>
        <button 
          onClick={DeleteEvent} 
          type="button" 
          className="btn btn-danger"
          disabled={pending}
        >
          {!pending ? (
            <span className="px-2">Yes, Delete</span>
          ) : (
            <span className="d-flex align-items-center gap-2">
              <Spinner as="span" animation="border" size="sm" />
              Deleting...
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

DeleteEvent.propTypes = {
  setIsToggleDelete: PropTypes.func.isRequired,
  DeleteEvent: PropTypes.func.isRequired,
  pending: PropTypes.bool.isRequired,
  eventName: PropTypes.string, // Optional prop for better UX
};

export default DeleteEvent;